var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "is-clearfix" }, [
      _c(
        "a",
        { staticClass: "is-pulled-right", on: { click: _vm.deleteAccion } },
        [_c("i", { staticClass: "fas fa-times-circle fa-lg" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "is-pulled-left" }, [
        _c("h3", { staticClass: "subtitle is-5" }, [_vm._v("Parametros")]),
        _vm._v(" "),
        _c("h3", { staticClass: "title is-6" }, [
          _vm._v(_vm._s(_vm.accion.nombre)),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [
        _vm._v("Descripción de la acción"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "control" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.descripcion,
              expression: "descripcion",
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true },
              expression: "{required: true}",
            },
          ],
          staticClass: "input",
          class: { "is-danger": _vm.errors.has("Descripcion de la acción") },
          attrs: { name: "Descripcion de la acción" },
          domProps: { value: _vm.descripcion },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.descripcion = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "help" }, [
          _vm._v("Describa en detalle de que se trata la acción"),
        ]),
        _vm._v(" "),
        _vm.errors.has("Descripcion de la acción")
          ? _c("span", { staticClass: "help is-danger" }, [
              _vm._v(_vm._s(_vm.errors.first("Descripcion de la acción"))),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.parametrosArray.includes("subunidad")
      ? _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Subunidad")]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select is-fullwidth" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.subunidadSelected,
                      expression: "subunidadSelected",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: { name: "Subunidad" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.subunidadSelected = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("- Seleccione una subunidad -")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.serieDocumental.estructura, function (s, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: index } },
                      [_vm._v(_vm._s(s.nombre))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.errors.has("Subunidad")
      ? _c("span", { staticClass: "help is-danger" }, [
          _vm._v(_vm._s(_vm.errors.first("Subunidad"))),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.parametrosArray.includes("aspecto_id")
      ? _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control" }, [
            _c("div", { staticClass: "select is-fullwidth" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.aspectoSelected,
                      expression: "aspectoSelected",
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: { name: "Aspecto" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.aspectoSelected = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { attrs: { disabled: "" }, domProps: { value: null } },
                    [_vm._v("- Seleccione un aspecto -")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.aspectosSerie, function (a, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: a.id } },
                      [_vm._v(_vm._s(a.nombre))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }